import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { JobGeneralState, JobGeneralStore } from './job-general.store';
import { GeneralJobType, JobGeneral } from '@data/job-general/job-general.model';
import { ObservableUtil } from '@shared/util/observable.util';

@Injectable({ providedIn: 'root' })
export class JobGeneralQuery extends QueryEntity<JobGeneralState, JobGeneral> {
  protected override store: JobGeneralStore;

  selectWhenLoaded$ = ObservableUtil.takeWhenTruthy(this.selectLoading(), (it) => !it);

  generalJobs$ = this.selectAll({
    filterBy: (it) =>
      it.type === GeneralJobType.BOOKABLE || it.type === GeneralJobType.SPECIALIZATION,
  });

  constructor() {
    const store = inject(JobGeneralStore);

    super(store);

    this.store = store;
  }

  selectSpecializationsForJob(jobType: string) {
    return this.selectAll({ filterBy: (it) => it.type === 4 && it.parentJobId === jobType });
  }

  denormalizeName(job: JobGeneral): Pick<JobGeneral, 'name'> {
    if (job.type === GeneralJobType.SPECIALIZATION) {
      const parentJob = this.getAll().find((it) => it.id === job.parentJobId);
      if (!parentJob) {
        return job;
      }

      return {
        name: {
          de: `${parentJob.name.de} - ${job.name.de}`,
          en: `${parentJob.name.en} - ${job.name.en}`,
        },
      };
    } else {
      return job;
    }
  }
}
